module.exports = __webpack_public_path__ + "img/toggle-unselect2.c15c0620.png";